import React, { useState } from 'react';
import ImageLightbox from './ImageLightbox';
import furnishFallback from '../assets/Capture.JPG';

const furnishCornerImages = require.context(
  '../assets/Furnish Every Corner',
  false,
  /\.(jpe?g|png|webp)$/i
);
const furnishImageKeys = furnishCornerImages.keys().sort();
const furnishHeroSrc =
  furnishImageKeys.length > 0 ? furnishCornerImages(furnishImageKeys[0]) : furnishFallback;

const FurnishEveryCorner = () => {
  const [lightbox, setLightbox] = useState(null);
  const categories = [
    'Bespoke Living',
    'The Nook Concept',
    'Master Suites',
    'Executive Spaces'
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-16" style={{background: 'linear-gradient(135deg, #EDE3D3, #E6D5C3)'}}>
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-12 items-center gap-8 sm:gap-12 md:gap-16">
        {/* Left Column - Categories List */}
        <div className="md:col-span-4 order-2 md:order-1">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 md:mb-12 tracking-tighter" style={{color: '#1C1C1E'}}>Furnish Every Corner</h2>
          <ul className="space-y-4 sm:space-y-6 md:space-y-8 font-headline text-lg sm:text-xl md:text-2xl font-light">
            {categories.map((category) => (
              <li 
                key={category}
                className="flex items-center gap-3 sm:gap-4 group cursor-pointer hover:translate-x-2 transition-transform"
              >
                <span className="w-8 sm:w-10 md:w-12 h-[1px] bg-stone-300 group-hover:bg-primary group-hover:w-10 sm:group-hover:w-12 md:group-hover:w-16 transition-all"></span>
                <span className="group-hover:text-primary transition-colors text-sm sm:text-base md:text-lg" style={{color: '#1C1C1E'}}>{category}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Column - Image */}
        <div className="md:col-span-8 order-1 md:order-2 relative">
          <div
            role="button"
            tabIndex={0}
            className="aspect-[16/10] rounded-xl overflow-hidden shadow-2xl cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C8A96A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#EDE3D3]"
            style={{boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'}}
            onClick={() =>
              setLightbox({
                src: furnishHeroSrc,
                alt: 'Furnish every corner — curated interior by Jatin Interiors',
              })
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setLightbox({
                  src: furnishHeroSrc,
                  alt: 'Furnish every corner — curated interior by Jatin Interiors',
                });
              }
            }}
          >
            <img 
              className="w-full h-full object-cover pointer-events-none" 
              alt="Furnish every corner — curated interior by Jatin Interiors" 
              src={furnishHeroSrc}
            />
          </div>
          
          {/* Quote Card */}
          <div className="absolute -bottom-4 sm:-bottom-6 md:-bottom-8 -left-4 sm:-left-6 md:-left-8 bg-white p-6 sm:p-8 md:p-10 rounded-xl shadow-xl max-w-xs hidden sm:block" style={{boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'}}>
            <p className="italic font-light text-sm sm:text-base md:text-lg leading-relaxed" style={{color: '#1C1C1E'}}>
              "The sofa isn't just furniture; it's the anchor of your domestic narrative."
            </p>
            <p className="mt-3 sm:mt-4 font-bold uppercase tracking-widest text-xs" style={{color: '#1C1C1E'}}>— Jatin Interiors Philosophy</p>
          </div>
        </div>
      </div>

      <ImageLightbox
        isOpen={!!lightbox}
        src={lightbox?.src ?? null}
        alt={lightbox?.alt ?? ''}
        onClose={() => setLightbox(null)}
      />
    </section>
  );
};

export default FurnishEveryCorner;
